"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Auth_1 = require("../stores/Auth");
function get(url) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, request('GET', url, null)];
        });
    });
}
exports.get = get;
function del(url) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, request('DELETE', url, null)];
        });
    });
}
exports.del = del;
function put(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, request('PUT', url, data)];
        });
    });
}
exports.put = put;
function post(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, request('POST', url, data)];
        });
    });
}
exports.post = post;
function request(method, url, data) {
    return __awaiter(this, void 0, void 0, function () {
        var isBadRequest, is500Error, body, headers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isBadRequest = false;
                    is500Error = false;
                    body = data;
                    headers = new Headers();
                    //DEBUG
                    console.log(url);
                    if (Auth_1.default.getUser()) {
                        headers.set('Authorization', "Bearer " + Auth_1.default.getUser().token);
                    }
                    headers.set('Accept', 'application/json');
                    if (data && !(data instanceof FormData)) {
                        if ((typeof data === 'object')) {
                            headers.set('Content-Type', 'application/json');
                            body = JSON.stringify(data);
                        }
                        else {
                            headers.set('Content-Type', 'application/x-www-form-urlencoded');
                        }
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: method,
                            headers: headers,
                            body: body,
                        }).then(function (response) {
                            if (response.status === 401) {
                                Auth_1.default.removeUser();
                                window.location.replace('/');
                            }
                            isBadRequest = (response.status === 400);
                            is500Error = (response.status === 500);
                            var responseContentType = response.headers.get("content-type");
                            if (responseContentType && responseContentType.indexOf("application/json") !== -1) {
                                return response.json();
                            }
                            else {
                                return response.text();
                            }
                        }).then(function (responseContent) {
                            if (is500Error) {
                                return {
                                    isError: true,
                                    errorContent: {
                                        errorMessage: 'There was an error processing your request.'
                                    }
                                };
                            }
                            var response = {
                                isError: isBadRequest,
                                errorContent: isBadRequest ? responseContent : null,
                                content: isBadRequest ? null : responseContent
                            };
                            return response;
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=RestUtilities.js.map